import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CollapseBlock, RawHtml } from '../index.jsx';
import { FoBasicInformation } from '../FriOpen/FoBasicInformation.jsx';
import { useIngProjectsBasicInformation } from '../../../hooks/useIngProjectsBasicInformation.jsx';
import useUserHasRole from '../../../hooks/useUserHasRoles.jsx';
import { ROLE_ING_PROJECTS_ADMIN } from '../../../utils/constants/roles.js';
import '../styles/DetailTable.sass';
import '../styles/RichContent.sass';

const IngProjectsDetail = ({ project, beforeContent = null }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const isIngProjectsAdmin = useUserHasRole([ROLE_ING_PROJECTS_ADMIN]);
  const isStudent = !isIngProjectsAdmin && !!user?.permissions?.['ing-projects-student'];
  const basicInformation = useIngProjectsBasicInformation(project, isStudent);

  return (
    <div style={{ margin: '10px' }}>
      {beforeContent}
      <div className="detail-collapse">
        <CollapseBlock title={t('Základné informácie o projekte')} collapsible={true}>
          <FoBasicInformation dataToRender={basicInformation} />
        </CollapseBlock>

        <CollapseBlock title={t('Popis')} collapsible={true}>
          <div className="detail-rich-section">
            {project.description ? (
              <RawHtml className="rich-content rich-content--lead add-icons-to-file-anchors">
                {project.description}
              </RawHtml>
            ) : (
              '–'
            )}
          </div>
        </CollapseBlock>

        {project.notes ? (
          <CollapseBlock title={t('Doplňujúce informácie')} collapsible={true}>
            <div className="detail-rich-section">
              <RawHtml className="rich-content add-icons-to-file-anchors">
                {project.notes}
              </RawHtml>
            </div>
          </CollapseBlock>
        ) : null}
      </div>
    </div>
  );
};

IngProjectsDetail.propTypes = {
  project: PropTypes.object.isRequired,
  beforeContent: PropTypes.node,
};

export default IngProjectsDetail;
